import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: null,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
      state.loading = false;
      state.error = null;
    },
    setUserLoading: (state, action) => {
      state.loading = action.payload;
    },
    setUserError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearUserInfo: (state) => {
      state.userInfo = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setUserInfo, setUserLoading, setUserError, clearUserInfo } = userSlice.actions;
export default userSlice.reducer;
